






































































































































































import { Component, Vue, Prop } from "vue-property-decorator";
import HhSurveilansService from "@/services/HhSurveilansService";

@Component
export default class HhSurveilansDetail extends Vue {
  @Prop({ required: true }) sessionId!: number;

  session: any = null;

  approveDialog = false;
  approvePassword = "";
  approving = false;

  temuanDialog = false;
  savingTemuan = false;
  temuanForm: any = {
    temuan_text: "",
    akar_masalah: "",
    rencana_tindak_lanjut: "",
    target_selesai: ""
  };

  temuanHeaders = [
    { text: "#", value: "urutan", width: 40 },
    { text: "Temuan", value: "temuan_text" },
    { text: "Rencana", value: "rencana_tindak_lanjut" },
    { text: "PIC", value: "pic.identitas.nama" },
    { text: "Target", value: "target_selesai" },
    { text: "Status", value: "status_tindak_lanjut" }
  ];

  async mounted() {
    await this.reload();
  }

  async reload() {
    const res = await HhSurveilansService.find(this.sessionId);
    this.session = res.data.data;
  }

  get complianceColor() {
    if (!this.session) return "grey";
    const r = this.session.compliance_rate;
    if (r >= 85) return "success";
    if (r >= 70) return "warning";
    return "error";
  }

  tindakLanjutColor(status: string) {
    return (
      {
        open: "orange",
        in_progress: "blue",
        closed: "success",
        overdue: "error"
      } as any
    )[status] || "grey";
  }

  printPdf() {
    HhSurveilansService.printPdf(this.sessionId);
  }

  openApprove() {
    this.approvePassword = "";
    this.approveDialog = true;
  }

  async approve() {
    this.approving = true;
    try {
      await HhSurveilansService.approveTimPpi(this.sessionId, { password: this.approvePassword });
      this.approveDialog = false;
      await this.reload();
    } finally {
      this.approving = false;
    }
  }

  tambahTemuan() {
    this.temuanForm = {
      temuan_text: "",
      akar_masalah: "",
      rencana_tindak_lanjut: "",
      target_selesai: ""
    };
    this.temuanDialog = true;
  }

  async saveTemuan() {
    this.savingTemuan = true;
    try {
      await HhSurveilansService.storeTemuan(this.sessionId, this.temuanForm);
      this.temuanDialog = false;
      await this.reload();
    } finally {
      this.savingTemuan = false;
    }
  }

  formatDate(s: string) {
    if (!s) return "-";
    return new Date(s).toLocaleDateString("id-ID");
  }

  formatDateTime(s: string) {
    if (!s) return "-";
    return new Date(s).toLocaleString("id-ID", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit"
    });
  }
}
